import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetAssessmentResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetAssessmentResultCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetAssessmentResultCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the three; a null count (that group's query failed) becomes a null
  // aggregate so the badge blanks rather than reading as 0.
  mapTrpcDataToGraphQL: (data) => ({
    risk_assessment_result_aggregate: {
      aggregate: toAggregate(data.assessmentResult.risk_assessment_result),
    },
    document_assessment_result_aggregate: {
      aggregate: toAggregate(data.assessmentResult.document_assessment_result),
    },
    obligation_assessment_result_aggregate: {
      aggregate: toAggregate(
        data.assessmentResult.obligation_assessment_result
      ),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAssessmentResultCountDocument,
});
